import { defineContent } from './defineContent.js';
import data from './whyCarii.json';
import { whyCariiSchema } from './whyCarii.schema.js';

export const whyCarii = defineContent(whyCariiSchema, data);
